import { Tooltip } from '@/components/primitives/Tooltip'

import { Row } from '../../Row'

import { useTexts } from '../useTexts'

interface Props {
  count: number
  onSelect: () => void
}

export function OrdersExpiring(props: Props) {
  const { count, onSelect } = props
  const texts = useTexts()

  return (
    <Tooltip
      textAlign="left"
      placement="right"
      title={texts.expiring}
      subtitle={texts.expiringTooltip}
    >
      <Row
        onClick={onSelect}
        text={texts.expiring}
        value={count}
        disabled={count === 0}
        testId="plan-summary-expiring-orders"
      />
    </Tooltip>
  )
}
